import { Code } from "@connectrpc/connect";
import { getCadendarRpcErrorCode } from "../main/components/cadendarRpc";

export function getStickiesErrorMessage(error: unknown) {
  if (error instanceof Error) {
    if (error.message === "Praticien sélectionné introuvable.") {
      return error.message;
    }
    if (error.message.endsWith("invalide.")) {
      return error.message;
    }
  }

  switch (getCadendarRpcErrorCode(error)) {
    case Code.PermissionDenied:
      return "Vous n'êtes pas autorisé à modifier ces notes.";
    case Code.InvalidArgument:
      return "La note est invalide.";
    case Code.NotFound:
      return "Cette note n'existe plus ou appartient à un autre praticien.";
    case Code.Unavailable:
      return "Le service des notes est temporairement indisponible.";
    default:
      return "Impossible de charger ou d'enregistrer les notes pour le moment.";
  }
}
